import isImgCorrect from "@/services/isImgCorrect.ts";

const checkImg = async (el, value) => {
  let imgUrl = value.url;

  const isCorrect = await isImgCorrect(value.url);
  if (!isCorrect) {
    imgUrl = "/img/img/placeholder.svg";
    value.failClassForPlaceholder
      ? el.classList.add(value.failClassForPlaceholder)
      : null;
    await isImgCorrect(imgUrl);
    value.classOnFail ? el.classList.add(value.classOnFail) : null;
  } else {
    value.classOnSuccess ? el.classList.add(value.classOnSuccess) : null;
  }
  el.style.backgroundImage = `url('${imgUrl}')`;
  value.failClass ? el.classList.add(value.failClass) : null;
};

export default {
  bind: async (el, { value }) => {
    await checkImg(el, value);
  },
  componentUpdated: async (el, { value }) => {
    await checkImg(el, value);
  }
};
